import { Component } from 'react';
import '../../assets/styles/emc.scss';
import BookdocApi from '../../services/BookdocApi';
import SearchForm from './SearchForm';
import EMCFound from './EMCFound';
import EMCNotFound from './EMCNotFound';
import {useParams} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Carousel from 'react-bootstrap/Carousel';

import whatIsEmcImg from '../../assets/images/emc/what-is-emc.png';
import easeWithRecoveryImg from '../../assets/images/emc/ease-with-recovery.png';
import step1Img from '../../assets/images/emc/step-1.png';
import step2Img from '../../assets/images/emc/step-2.png';
import step3Img from '../../assets/images/emc/step-3.png';

import step1Icon from '../../assets/images/emc/one.svg';
import step2Icon from '../../assets/images/emc/two.svg';
import step3Icon from '../../assets/images/emc/three.svg';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class EMCVerificationPortal extends Component {

    constructor(props) {
        super(props);

        document.title = 'Medical Certificate - BookDoc';
        this.state = {
            emc_url: null,
            error_message: null,
        };
    }

    steps = [{
        img: step1Img,
        icon: step1Icon,
        title: "Get the shared E-MC From<br/>Doctor BookDoc app",
        subtitle: "Employee receives an E-Medical<br/>Certificate from their doctor."
      },{
        img: step2Img,
        icon: step2Icon,
        title: "Check E-MC Validation on<br/>BookDoc’s Website",
        subtitle: "Input the E-MC Document ID<br/>and click 'Verify'."
      },{
        img: step3Img,
        icon: step3Icon,
        title: "Get the Verification Status<br/>of the E-MC",
        subtitle: "Verify the document's authenticity<br/>and view the file if needed."
      }]

    componentDidMount() {
        //When this page is shown
        //No need to do anything
        if (!!this.props.params.reference_id){
            this.findDocument(this.props.params.reference_id);
        }
    }

    handleSearch = (e) => {
        e.preventDefault();
        //1. need to call api to search for this emc
        this.setState({
            emc_url: null,
            error_message: null,
        })
        var referenceId = "";
        if (document.getElementById('search').value.length > 0) {
            referenceId = document.getElementById('search').value;
        }
        this.findDocument(referenceId);
    }

    findDocument(referenceId){
        if (referenceId.trim() === ''){
            return;
        }else{
            BookdocApi.getEMCDetails({
                reference_id: referenceId
            }).then((data) => {
                if ('errors' in data){
                    this.setState({
                        error_message: data.errors[0],
                    })
                }else{
                    this.setState({
                        emc_url: data.url,
                    })
                }
            });
        }
    }

    stepDetails = (step, index) => {
        return <div className="d-flex flex-column align-items-center text-center" key={index}>
            <div className="step-img-container"><img src={step.img} alt="step-1-img" className="step-img"/></div>
            <img src={step.icon} alt="step-1-icon" className="step-icon"/>
            <h3 dangerouslySetInnerHTML={{ __html: step.title }} />
            <p dangerouslySetInnerHTML={{ __html: step.subtitle }} />
        </div>
    }

    render() {
        return (
            <div className="e-mc">
                <Helmet>
                    <meta property="og:title" content="Medical Certificate Verification for HR" />
                    <meta property="og:description" content="Verify your employees' certificates hassle-free with our trusted platform. Instantly confirm authenticity and validity, empowering your corporate compliance effortlessly." />
                    <meta name="description" content="Verify your employees' certificates hassle-free with our trusted platform. Instantly confirm authenticity and validity, empowering your corporate compliance effortlessly."/>
                </Helmet>
                <h1 className="title">E-Medical Certificate (E-MC)</h1>
                <h2 className="subtitle">Verify a e-medical certificate issued by one of our doctors on the BookDoc app.</h2>
                <SearchForm handleSearch={this.handleSearch} defaultReferenceNo={this.props.params.reference_id}></SearchForm>
                {this.state.emc_url && <EMCFound url={this.state.emc_url} />}
                {this.state.error_message && <EMCNotFound error_message={this.state.error_message} />}

                <div className="steps-section desktop-view">
                    {
                        this.steps.map((step, index) => (
                            this.stepDetails(step, index)
                        ))
                    }
                </div>
                <Carousel className="steps-section mobile-view" controls={false}>
                    {
                        this.steps.map((step, index) => (
                            <Carousel.Item key={`carousel-item-${index}`}>
                                {this.stepDetails(step, index)}
                            </Carousel.Item>
                        ))
                    }
                </Carousel>

                <div className="what-is-emc-section">
                    <div className="information-container container">
                        <img className="section-main-img" src={whatIsEmcImg} alt="what-is-emc"/>
                        <div className="details">
                            <h1 className="section-title">What is E-MC?</h1>
                            <p>An e-medical certificate (E-MC) is the digital alternative to traditional paper certificates. Consult a doctor via video call from home for a valid E-MC.</p>
                            <p>After your video consultation, if the doctor determines you're unfit for duty, an E-MC will be issued in-app. Access it in the history section for download.</p>
                            <a className="btn consultation-btn" href={`${process.env.REACT_APP_DEEPLINK_URL}/teleconsult`} target="_blank" rel="noopener noreferrer">Book A Consultation</a>
                        </div>
                    </div>
                </div>
                <div className="ease-with-recovery-section">
                    <div className="information-container container">
                        <img className="section-main-img" src={easeWithRecoveryImg} alt="ease-with-recovery"/>
                        <div className="details">
                            <h1 className="section-title">Ease into Recovery</h1>
                            <p>Consult a doctor from home and receive a valid medical certificate digitally. Choose from a selection of qualified professionals for confidential video consultations.</p>
                            <p>Rest easy while our doctors provide expert care, ensuring a smooth recovery process.</p>
                            <a className="btn consultation-btn" href={`${process.env.REACT_APP_DEEPLINK_URL}/teleconsult`} target="_blank" rel="noopener noreferrer">Book A Consultation</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withParams(EMCVerificationPortal);
